/** @jsx jsx */
import { Box, EmptyState, EmptyStateList, EmptyStateListWhite } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

interface TimeReportSpecificationEmptyStateProps {
  editable?: boolean;
}

export const TimeReportSpecificationEmptyState: FC<TimeReportSpecificationEmptyStateProps> = ({ editable }) => {
  const { t } = useTranslation("session");

  return (
    <Box sx={{ py: 120 }} px="sm">
      <EmptyState
        icon={editable ? <EmptyStateList /> : <EmptyStateListWhite />}
        title={t("TIME_REPORTS.SPECIFICATION.EMPTY_HEADER")}
        content={t("TIME_REPORTS.SPECIFICATION.EMPTY_MESSAGE")}
      />
    </Box>
  );
};
